module.exports = __webpack_public_path__ + "static/media/NotoSans-ExtraBold.0fe803fc.woff";